import styled from 'styled-components';

export const SplitContainer = styled.div`
  display: flex;
  // min-height: 712px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    min-height: auto;
  }
`;

export const ImageContainer = styled.div`
  width: 50%;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
    height: 300px;
  }

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    left: 0;
    top: 0;
  }
`;

export const ContentContainer = styled.div`
  width: 50%;
  padding: ${({ theme }) => theme.spacing.lg};
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 90%;
    padding: 0 ${({ theme }) => theme.spacing.sm};
  }
`;
